import AdminCompliancePage from './AdminCompliancePage';

export default AdminCompliancePage;
